import {useEffect} from "react";
import ReportUtils from "../../../../../utils/report-utils.js";
import ProjectUtils from "../../../../../utils/project-utils.js";
import {FaTriangleExclamation} from "react-icons/fa6";

export default function ReportContent({ data, searchDetails }) {

    useEffect(() => {
        if (searchDetails) {
            const effectiveValues = data.map(effective => [
                ProjectUtils.formatCpfToView(effective.cpf),
                effective.name,
                effective.namewar,
                effective.total
            ]);

            ReportUtils.createExportableTable(
                ["CPF", "Nome", "Nome de guerra", "Total de duração dos cursos (horas)"],
                effectiveValues,
                "Efetivos"
            );
        } else {
            ReportUtils.createExportableTable(null, null, 'Efetivos', "effective-data");
        }

        if (searchDetails) {
            const trainingData = [];

            data.forEach(effective => {
                const trainings = JSON.parse(effective.training_data || "[]");

                trainings.forEach(training => {
                    const expiration = ReportUtils.expired(training.expiration);

                    trainingData.push([
                        effective.name,
                        training.course_name,
                        ReportUtils.formatDateLabel(training.start_date),
                        ReportUtils.formatDateLabel(training.conclusion_date),
                        ReportUtils.formatDateLabel(expiration.text),
                        training.work_load ?? "Não informado"
                    ]);
                });
            });

            ReportUtils.createExportableTable(["Agente", "Nome do curso", "Data de início", "Data de conclusão", "Data de validade", "Duração"], trainingData, "Detalhes");
        }
    }, [data, searchDetails]);

    return (
        <>
            <table id="effective-data" className="table report-table" sheet-name="Efetivos">
                <thead className="thead-background">
                    { !searchDetails && (
                        <tr className="bg-[#f6f6f6] text-left">
                            <th className={'w-[12%]'}>CPF</th>
                            <th className={'w-[45%]'}>Nome</th>
                            <th className={'w-[18%]'}>Nome de guerra</th>
                            <th className={'w-[25%]'}>Total de duração dos cursos (horas)</th>
                        </tr>
                    )}
                </thead>

                <tbody className="bg-white">
                    { data.map((element, index) => {
                        const trainings = JSON.parse(element.training_data || "[]");

                        return (
                            <>
                                <tr key={index} className={`${searchDetails ? 'details-row' : ''}`}>
                                    <td className={`${searchDetails ? '!text-center w-[20%]' : "w-[12%]"}`}>
                                        { searchDetails ? (
                                            <><span>CPF: </span><span className="font-bold">{ProjectUtils.formatCpfToView(element.cpf)}</span></>
                                        ) : (
                                            ProjectUtils.formatCpfToView(element.cpf)
                                        )}
                                    </td>

                                    <td className={`${searchDetails ? '!text-center w-[25%]' : "w-[45%]"}`}>
                                        { searchDetails ? (
                                            <><span>Nome: </span> <span className="font-bold"> {element.name} </span></>
                                        ) : (
                                            element.name
                                        )}
                                    </td>

                                    <td className={`${searchDetails ? '!text-center w-[25%]' : "w-[18%]"}`}>
                                        { searchDetails ? (
                                            <><span>Nome de guerra: </span> <span className="font-bold"> {element.namewar} </span></>
                                        ) : (
                                            element.namewar
                                        )}
                                    </td>

                                    <td className={`${searchDetails ? '!text-center w-[30%]' : "w-[25%]"}`}>
                                        { searchDetails ? (
                                            <><span>Total de duração dos cursos (horas): </span> <span className="font-bold"> {element.total}</span></>
                                        ) : (
                                            element.total
                                        )}
                                    </td>
                                </tr>

                                { searchDetails && trainings.length > 0 && (
                                    <tr className={'export-ignore'}>
                                        <td colSpan={4}>
                                            <table id='trainings-data' className="table max-w-[95%] mx-auto" sheet-name='Detalhes'>
                                                <thead className="thead-background">
                                                    <tr className="!bg-[#f6f6f6] text-left">
                                                        <th className={'w-[40%]'}>Nome do curso</th>
                                                        <th className={'w-[15%]'}>Data de início</th>
                                                        <th className={'w-[15%]'}>Data de conclusão</th>
                                                        <th className={'w-[15%]'}>Data de validade</th>
                                                        <th className={'w-[15%]'}>Duração</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    { trainings.map((element, index) => (
                                                        <tr key={index}>
                                                            <td className={'w-[40%]'}>{element.course_name}</td>
                                                            <td className={'w-[15%]'}>{ReportUtils.formatDateLabel(element.start_date)}</td>
                                                            <td className={'w-[15%]'}>{ReportUtils.formatDateLabel(element.conclusion_date)}</td>
                                                            <td className={'w-[15%]'}>
                                                                {(() => {
                                                                    const expiration = ReportUtils.expired(element.expiration);

                                                                    return expiration.expired ? (
                                                                        <span className="flex items-center gap-2 text-red-600" title="Vencido">
                                                                            {ReportUtils.formatDateLabel(expiration.text)} <FaTriangleExclamation className={'transform -translate-y-[1px]'}/>
                                                                        </span>
                                                                    ) : (
                                                                        ReportUtils.formatDateLabel(expiration.text)
                                                                    );
                                                                })()}
                                                            </td>
                                                            <td className={'w-[15%]'}>{element.work_load !== '' ? element.work_load : "Não informado"}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                )}
                            </>
                        );
                    })}
                </tbody>
            </table>

            <div id="chart-tables"/>

        </>
    )
}
